/* eslint-disable max-len */
export default {
  common: {
    save: 'Сохранить',
    saveChanges: 'Сохранить изменения',
    revertChanges: 'Отменить изменения',
    or: 'или',
    and: 'и',
    pleaseWait: 'Пожалуйста подождите',
    done: 'Готово',
    add: 'Добавить',
    confirm: 'Подтвердить',
    continueWorking: 'Продолжить работу',
    ok: 'ОК',
    cancel: 'Отмена',
    refuse: 'Отказаться',
    edit: 'Редактировать',
    somethingWentWrong: 'Что-то пошло не так',
    error500: 'Сервис недоступен',
    operationFailed: 'При выполнении операции произошла ошибка',
    retry: 'Попробовать ещё раз',
    pleaseRetry: 'Пожалуйста, попробуйте обновить страницу',
    serviceDisconnected: 'Услуга не подключена',
    super: 'Супер',
    send: 'Отправить',
    account: 'Аккаунт',
    pricePerMonth: '{{SUM}} ₽ в месяц',
    showMore: 'Показать ещё {{COUNT}}',
    priceLabel: 'Стоимость',
  },
  familyInvitationsPopup: {
    termUse: 'Нажимая кнопку "Принять приглашение", я соглашаюсь с',
  },
  home: {
    accountStatus: {
      blocked: 'Номер заблокирован',
    },
    accumulators: {
      blockTitle: 'Мобильная связь',
      blockDescription: 'Доступный мобильный интернет, минуты и SMS',
      lteFree: '+ Безлимитный 4G интернет',
      autoSpeedUp: 'Автопродление',
      autoSpeedUpTooltip: 'Автопродление сработало, т.к. доступный трафик был исчерпан',
      speedUpLink: 'Докупить интернет-трафик',
      accumulatorInfo: 'Осталось {{INFO}}',
      updateDate: 'Обновим {{DATE}}',
      updateDateSize: 'Обновим {{DATE}} до {{SIZE}}',
      constructor: {
        desktop: 'Настройте тариф — обменяйте минуты и SMS на гигабайты и наоборот',
        mobile: 'Настройте тариф',
      },
      unlimited: 'Безлимитно',
      unlimGiftedExpDate: 'Подарок действует до {{DATE}}',
    },
    internet: {
      blockTitle: 'Домашний интернет',
    },
    tv: {
      blockTitle: 'Телевидение',
    },
    insurance: {
      blockTitle: 'Страхование квартиры',
    },
    additionalBalances: {
      blockTitle: 'Дополнительные балансы',
      rest: 'Осталось {{REST}}',
      dueDate: 'Доступно до {{DUEDATE}}',
      noDueDate: 'Доступен бессрочно',
      sasName: 'Для платежей и переводов',
      sasTooltip: 'Данный баланс используется для оплаты сервисов услуги «Мобильный платёж» или сервисов провайдеров на коротких номерах',
      sasShowLink: 'Показать баланс',
      sasPayButton: 'Пополнить баланс',
    },
    associatedAccounts: {
      blockTitle: 'Привязанные номера',
      blockInfo: 'Вы можете управлять этими аккаунтами, как своими',
      emptyMessage: 'У вас ещё нет привязанных номеров',
      settingsButton: 'К настройкам',
    },
    balance: {
      blockTitle: {
        prepaid: 'Баланс на счёте',
        postpaid: 'Расход по номеру',
      },
      dateFrom: 'c {{DATE}}',
      payButton: 'К оплате',
      autoMtopupPayment: 'Автооплата',
      autoBankPayment: 'Автоплатёж',
      personalCreditLimit: {
        permanentSocDescription: 'Вы можете общаться до {{AMOUNT}} ₽',
        permanentSocWithNegativeBalanceDescription: 'Вы можете общаться до {{AMOUNT}} ₽ до {{DATE}}',
        temporarySocDescription: 'ожидает внесения на ваш счет суммы гарантийного платежа в размере {{AMOUNT}} ₽',
        depositTooltip: 'Гарантийный платеж будет возвращен на ваш счет через 3 месяца пользования услугой',
        depositReturnDate: 'Гарантийный платёж вернётся {{DATE}}',
      },
      happyTime: {
        available: 'Вы с нами больше двух лет! Чтобы получить скидку {{PERCENT}}% в ближайший счет по программе «Счастливое время» наберите *805#',
        activated: 'Скидка {{PERCENT}}% по программе «Счастливое время» будет применена к следующему выставленному счету {{DATE}}',
      },
      unavailable: 'Не удалось узнать баланс на счете. Попробуйте обновить позже',
      promisedPaymentInfo: 'К погашению {{AMOUNT}} до {{DATE}}',
      promisedPaymentInfoWithoutDate: 'К погашению {{AMOUNT}}',
      promisedPaymentDescription: 'Зачислен {{NAME_PREFIX}}доверительный платёж на сумму {{AMOUNT}}. Оплатить до {{DATE}}. Стоимость предоставления услуги {{FEE}}',
    },
    balanceNotification: {
      days: 'Баланс на вашем счёте будет исчерпан через {{DAYS}}.',
      sum: 'Рекомендуемая сумма к оплате {{SUM}} {{CURRENCY}}',
    },
    payments: {
      blockTitle: 'Оплата',
      allPayments: 'Все способы оплаты',
    },
    bundlesSharing: {
      blockTitle: 'Вы делитесь мобильной связью',
      statusConfirmed: 'Подключен',
      statusNotConfirmed: 'Ждёт подтверждения',
      emptyMessage: 'Подключите дополнительные номера к этому тарифу и используйте вместе с ними включенные в тариф пакеты минут, SMS, интернета',
      addButton: 'Добавить номер',
      connectButton: 'Подключить номер',
      maxConnectedMessage: 'Подключено максимальное количество номеров',
    },
    services: {
      emptyMessage: 'Нет подключенных услуг',
      blockInfoLink: 'Перейти в каталог услуг',
    },
    summary: {
      blockTitle: 'Основная информация',
      balance: 'Баланс',
      ctnLabel: 'Номер',
      tariffLabel: 'Тариф',
      portedLabel: 'Ушёл из билайн',
      futureTariffLabel: 'Будущий тариф',
      futureTariffDate: 'Переход запланирован на {{DATE}}',
      tariffRateLabel: 'Абон. плата',
      catalogLink: 'Посмотреть все тарифы',
      spendingLimitLabel: 'Порог расх.',
      spendingLimitHint: 'При достижении этой суммы вам будет отправлено SMS сообщение',
      blockedMessage: 'Этот номер заблокирован',
      futureBlockMessage: 'Этот номер будет заблокирован {{DATE}}',
      futureUnblockMessage: 'Этот номер будет разблокирован {{DATE}}',
      blockButton: 'Заблокировать номер',
      anotherPayments: 'Другие списания',
      unblockButton: 'Разблокировать номер',
      cancelFutureStatusRequestButton: 'Отменить блокировку',
      cancelFutureTariff: 'Отменить переход на новый тариф',
      convergenceTariffRateInfo: 'Сумма без учета мобильных услуг с ежедневным списанием',
      sumToBePaid: 'К оплате',
      sumToBeConvergent: 'Рекомендуем оплатить',
      nextBillingDate: 'Оплатить до',
      nextBillingDateConvergent: 'Следующее списание абонентской платы',
      periodIsPaid: 'Текущий расчётный период оплачен до {{DATE}}. На балансе достаточно средств для оплаты следующего.',
    },
    internetExtension: {
      heading: 'Больше интернета',
      description: 'Рекомендуем докупить интернет-трафик. Оставшийся трафик скоро закончится. После этого скорость снизится до 64 Кбит/с.',
      autoSpeedUpDescription: 'Или включите автопродление — автоматическое добавление {{SIZE}} трафика, когда он заканчивается',
      autoSpeedUpPrice: '{{PRICE}} за каждые {{SIZE}}',
      autoSpeedUpLink: 'Включить автопродление',
    },
    mnpStatus: {
      applyId: 'Заявление № {{ID}}.',
      actualDate: 'Ожидаемая дата переноса: {{DATE}}.',
    },
    accountState: {
      title: 'Договор № {{BAN}}',
      owner: 'Владелец',
      invoiceAddress: 'Дост. счета',
      threshold: 'Порог расх.',
      thresholdTooltip: 'Порог расходов по договору',
      currentExpenses: 'Тек. расходы',
      available: 'Доступно',
      expensesLimit: 'Лимит расходов',
      expensesByOffer: 'Расходы по договору',
      offerBalance: 'Баланс договора',
      restOfLimit: 'Остаток лимита',
      limitIsExceeded: 'Лимит превышен на',
      expensesLimitHint: 'Лимит расходов - сумма, на которую вы можете общаться в текущем периоде. Для разблокировки достаточно оплатить счета и текущие расходы.',
    },
    postpaidBalance: {
      title: 'Баланс договора',
      rest: 'Остаток',
      toPay: 'К оплате',
      overdue: 'Просрочено',
      noInvoices: 'Все счета оплачены. Если вы хотите внести средства заранее, воспользуйтесь кнопкой ниже',
      overdueAlert: 'Просроченные счета необходимо срочно оплатить во избежании блокировки договора',
      invoicesLink: 'Посмотреть счета',
      invoicesDate: 'Выставленные счета необходимо оплатить в срок до {{DATE}}',
    },
    xbrStatus: {
      authorize: 'Авторизуйтесь',
      toFullAccess: 'чтобы получить доступ к управлению услугами и тарифом.',
    },
    warrantyPayments: {
      title: 'Гарантийные платежи',
      description: 'Для возврата платежей не меняйте тариф и своевременно оплатите 3 ежемесячных счёта',
      statuses: {
        Paid: 'Оплачен',
        Required: 'Запрошен',
      },
    },
    personalDataStatus: {
      dataRequired: 'Вам необходимо заполнить персональные данные по номеру.',
      fillForm: 'Перейти к заполнению',
      updateForm: 'Обновить данные',
      updateAuthorAndDate: 'Автор и дата последнего обновления персональных данных:\n{{AUTHOR}} от {{DATE}}.',
      updateDate: 'Дата последнего обновления персональных данных по номеру {{DATE}}.',
      blockDate: 'Если данные не будут заполнены до {{DATE}}, номер будет заблокирован',
    },
    simTransferRequestStatus: {
      title: 'Завершите процесс дистанционной замены SIM-карты',
      description: 'Зарегистрирована заявка на дистанционную замену SIM-карты.\nЕсли вы не оформляли заявку, обратитесь на бесплатную линию поддержки 0611.\nЕсли заявку оформили вы и уже получили новую SIM-карту, перейдите по ссылке для завершения процесса замены. ',
      linkText: 'Перейти по ссылке',
    },
    usisResultPopup: {
      success: {
        heading: 'Готово',
        description: 'Ваша заявка на обновление персональных данных принята',
        buttonText: 'Продолжить работу',
      },
      error: {
        heading: 'Ошибка',
        description: 'При создании заявки на обновление персональных данных произошла ошибка. Попробуйте повторить запрос позже.',
        buttonText: 'Продолжить работу',
      },
    },
    multiconvergenceOffer: {
      offerTitle: '{{TITLE}}',
      offerDescription: '{{DESCRIPTION}}',
      acceptOfferButton: 'Оставить заявку на подключение',
    },
  },
  services: {
    title: 'Подключённые услуги и информационные сервисы',
    blockMessage: 'Управление услугами будет доступно после снятия блокировки',
    servicesTitle: 'Услуги',
    subscriptionsPartnersTitle: 'Партнерские Сервисы',
    subscriptionsEntertainmentsTitle: 'Развлечения от билайн',
    servicesDisconnectMessage: 'Запрос №{{ID}} на отключение услуги успешно отправлен',
    subscriptionsDisconnectMessage: 'Запрос на отключение сервиса успешно отправлен',
    subscriptionsEmptyMessage: 'У вас нет ни одного сервиса.',
    settingsLink: 'Настройки услуги',
    settingsInsuranceLink: 'Подробнее об услуге',
    subscriptionsLoadingError: 'Не удалось загрузить сервисы.',
    servicesLoadingError: 'Не удалось загрузить услуги.',
    try: 'Попробуйте',
    refresh: 'обновить',
    inAMinute: 'через минуту.',
    goTo: 'Перейти в',
    subscriptionCatalog: 'каталог информационных сервисов',
    servicesCatalog: 'каталог мобильных услуг',
    statuses: {
      unsubscribableService: 'Услугу невозможно отключить',
      unsubscribableInsuranceService: 'Для расторжения полиса, пожалуйста, обратитесь в АО «АльфаСтрахование»',
      activeUntil: 'Услуга подключена до {{date}}',
      activeFrom: 'Услуга будет подключена {{date}}',
    },
    errorMessage: 'При отправке запроса произошла ошибка',
    futurePriceMessage: 'С {{date}} будет взиматься плата в соответствии с условиями подписки.',
    serviceDisconnectMessage: `Запрос на отключение услуги "{{service}}" успешно отправлен. За статусом запроса следите в <a href="/customers/products/mobile/profile/#/messages">истории запросов</a>
                                *При наличии включенных уведомлений, вам поступит оповещение о подключении`,
    tveEmptyMessage: 'Вы ещё не подключили ни одного устройства',
  },
  detalization: {
    createReport: 'Составить отчёт',
    saveReport: 'Сохранить отчёт',
    blockTitle: 'Детализация оказанных услуг',
    back: 'Вернуться назад',
    reportPeriod: {
      rangeError: 'Выгрузить детализацию за такой большой период нельзя. Установите срок в месяц и выгрузите детализацию за длинный период помесячно.',
      rangeErrorEmpty: 'Установите начальную и конечную даты детализации.',
    },
    reportPopup: {
      blockTitle: 'Детализация за период с\u00a0{{start}} по\u00a0{{end}}',
      loadingTitle: 'Формируем детализацию',
      loadingMessage: 'Это может занять до одной минуты',
      successTitle: 'Детализация сформирована',
      errorTitle: 'Ошибка при формировании детализации',
      inFormat: 'В формате:',
      saveDetalization: 'Сохранить детализацию',
      continue: 'Продолжить работу',
    },
    balances: {
      blockTitle: 'Ваш баланс и бонусы',
      emptyMessage: 'Вы ничего не тратили за выбранный период',
    },
    payments: {
      blockTitle: 'Платежи',
      emptyMessage: 'За выбранный период платежей не было',
      showAll: 'Показать все',
      paymentDate: 'Дата платежа',
      channel: 'Канал',
      phoneNumber: 'Номер телефона',
      paymentSum: 'Сумма платежа',
      paymentSumWithVat: 'Сумма платежа с НДС',
      statusText: 'Статус',
      invoiceNumber: 'Номер счета',
      benNumber: 'Группа',
      dueDate: 'Оплатить до',
      totalAmount: 'Сумма счета с НДС',
      paymentValue: 'Зачислено из платежа',
      unpaidAmount: 'Не оплачено',
      billStatus: 'Статус счета',
      overpayment: 'Переплата',
    },
    expenses: {
      emptyMessage: 'Нет данных за выбранный период',
      errorMessage: 'Что-то пошло не так. Попробуйте повторить чуть позже',
      tooManyTransactions: 'Слишком много транзакций за выбранный период, сохраните отчёт в файл',
      incorrectPeriod: 'Вы запросили некорректный период',
      structureTitle: 'Структура расходов с {{start}} по {{end}}',
      detalizationTitle: 'Расходы с {{start}} по {{end}}, в рублях',
      structureLink: 'Структура расходов',
      detailsLink: 'Детализация',
      reportSettings: 'Настройка отчёта',
      tooManyTransactionsTitle: 'Мы не можем отобразить такой длинный отчёт здесь, но вы можете сохранить его в виде файла:',
      onlyPaidFilter: 'Только платные операции',
      spendingStructure: {
        service: 'Сервис',
        volume: 'Объем услуг',
        sum: 'Сумма',
      },
      detailsTable: {
        userNumber: 'Номер абонента',
        dateTime: 'Дата и время',
        operation: 'Вид операции',
        number: 'Номер',
        trafficVolume: 'Объём услуг',
        balance: 'Баланс',
        balanceDiff: 'Изменение баланса',
        finalBalance: 'Конечный баланс',
        cost: 'Стоимость, с НДС',
      },
    },
    postpaidInvoices: {
      currentPeriod: 'Расходы за текущий период {{START}} — {{END}}',
      ctnTitle: 'Расходы за {{START}} — {{END}}',
      invoicePeriodsTitle: 'Выставленные счета',
      seeDetalization: 'Посмотреть детализацию',
      period: 'Период',
      group: 'Группа',
      mail: 'Отправка счета на почту',
      sum: 'Сумма счета с НДС',
      status: 'Статус',
      paid: 'Оплачен',
      notPaid: 'Не оплачен. Оплатить до {{DATE}}.',
      notPaidAmount: 'Осталось оплатить {{AMOUNT}} до {{DATE}}.',
      overduePayment: 'Не оплачен. Просрочка {{OVERDUE}} дней.',
      overduePaymentWithAmount: 'Осталось оплатить {{AMOUNT}}. Просрочка {{OVERDUE}} {{DAY}}.',
      billPayment: 'Оплата счета',
      invoiceSendingTitle: 'Отправка счета №{{INVOICE}} на почту',
      invoiceSendingSubtitle: 'За период {{START}} — {{END}}',
      emailLabel: 'Адрес электронной почты для отправки счета',
      sendInvoice: 'Отправить счет',
      invalidEmail: 'Введите корректный email',
      accountGroup: 'Группа счетов {{GROUP}}',
      phoneNumber: 'Номер телефона',
      preliminaryAmount: 'Предварительная сумма расходов',
      spendingLimit: 'Порог расходов',
      limitIsUnspecified: 'Порог расходов не задан',
      configure: 'Настроить',
      allInvoices: 'Все счета',
      notPaidInvoices: 'Неоплаченные',
      total: 'Итого',
      allPaid: 'У вас все счета оплачены',
      payment: 'К оплате',
      prepareReportTitle: 'Формируем отчет',
      prepareReportSubtitle: 'Это может занять до одной минуты',
      reportIsSent: 'Отчет отправлен на {{EMAIL}}',
      invoice: {
        title: 'Счет за {{START}} — {{END}}',
        group: 'Группа',
        invoiceNumber: 'Номер счета',
        amount: 'Сумма счета',
        status: 'Статус оплаты',
        saveReport: 'Сохранить отчёт',
        totalSpent: 'Всего потрачено',
        penalties: 'Пени',
        discount: 'Скидка',
        vat: 'НДС',
        total: 'Итого с НДС',
        discountName: 'Название',
        percentage: 'Размер',
        discountAmount: 'Сумма применения скидки',
        discountResult: 'Сумма скидки',
        saveDetalizationPopup: {
          title: 'Сохранение отчёта за {{START}} - {{END}} по счёту №{{INVOICE}}',
          ctnTitle: 'Сохранение отчёта за {{START}} - {{END}}',
          includeStructure: 'Сохранить структуру расходов',
          includeDetalization: 'Сохранить детализацию',
          sendToEmail: 'Отправить на электронную почту',
          saveReport: 'Сохранить отчёт',
          emailSettings: 'Настройка почты',
          emailIsNotSpecified: 'Не указан адрес электронной почты',
          goToSettings: 'к настройкам',
          successTitle: 'Детализация сформирована',
        },
      },
    },
    lastExpenses: {
      blockTitle: '5 последних списаний',
      emptyMessage: 'У вас не было списаний за последнюю неделю',
    },
    email: {
      emailIsNotSet: 'Не указан адрес электронной почты, ',
      toSettings: 'к настройкам',
      sendToMail: 'Отправить на адрес эл. почты ',
      mailConfiguration: 'Настройка почты',
    },
    homeInternet: {
      title: 'Статистика по Домашнему билайн',
      emptyMessage: 'Нет данных за выбранный период',
      internetStatsTable: {
        date: 'Месяц',
        duration: 'Время передачи трафика',
        received: 'Принято',
        transferred: 'Передано',
        cost: 'Стоимость',
      },
      cashflowStatsTable: {
        date: 'Дата и время',
        operation: 'Операция',
        startBalance: 'Начальный баланс',
        movementValue: 'Изменение баланса',
        endBalance: 'Конечный баланс',
      },
      traffic: 'Интернет-трафик',
      cashflow: 'Архив начислений',
    },
  },
  passwordAndAccess: {
    title: 'Надёжен ли ваш пароль?',
    description: 'Безопасный пароль должен состоять из букв, цифр и других символов. Если это не так, смените свой пароль на более надёжный. ',
    linkText: 'Сменить пароль',
  },
  settings: {
    common: {
      offerTitle: 'Условия оферты',
      sendNotificationPointCodeError: 'Не удалось отправить код подтверждения, попробуйте еще раз.',
    },
    points: {
      EMAIL: {
        title: 'По эл. почте',
        addTitle: 'Добавить почту',
        editTitle: 'Редактировать почту',
        confirmTitle: 'Подтвердить почтовый адрес',
        hint: 'Адрес также будет использован для восстановления пароля',
        recoveryPasswordHint: 'Адрес также будет использован для доставки уведомлений',
        error: 'Введите корректный email',
      },
      SMS: {
        title: 'С помощью SMS',
        addTitle: 'Добавить номер',
        editTitle: 'Редактировать номер',
        confirmTitle: 'Подтвердить номер',
        hint: 'Номер также будет использован для восстановления пароля',
        recoveryPasswordHint: 'Номер также будет использован для доставки уведомлений',
        error: 'Введите корректный номер',
      },
    },
    userForm: {
      name: 'Анкета абонента',
      title: 'Анкета абонента',
      filled: 'Заполнено',
      notFilled: 'Не заполнено',
      partiallyFilled: 'Заполнено {{PROGRESS}} из {{TOTAL}}',
      totalFillStatusTitle: 'Анкета заполнена на {{PERCENTAGE}}%',
      agreement: 'Данные анкеты не передаются третьим лицам',
      fillProgress: 'Осталось заполнить:',
      errors: {
        invalidDate: 'Введите корректную дату',
        invalidDateOfBirth: 'Внесение данных недоступно для лиц моложе 18 лет',
        invalidPhoneNumber: 'Введите корректный номер телефона',
        invalidEmail: 'Введите корректный e-mail',
        invalidStringFormat: 'Введите данные в корректном формате',
        invalidLength: 'Введите не {{COMPARISON}} {{NUMBER}} {{UNITS}}',
        required: 'Заполните поле',
        manualUpdate: 'Сервис временно недоступен. Попробуйте воспользоваться позднее или направить данные на <a href="mailto:persdannye@beeline.ru">persdannye@beeline.ru</a>',
      },
    },
    serviceContract: {
      name: 'Договор',
    },
    notifications: {
      name: 'Уведомления',
      title: 'Уведомления по электронной почте и SMS о мобильных событиях',
      homePointsTitle: 'Уведомления по электронной почте и SMS о домашних событиях',
      notifiableActionsTitle: 'Уведомлять о следующих событиях',
      notifiableActionsForTvConsolesTitle: 'Настройка уведомлений на ТВ-приставку',
      emptyMessageForTvConsoles: 'Нет приставок для настройки уведомлений',
      actions: {
        SSO_LINK_CHANGE: 'Предоставление другим абонентам доступа к управлению моими услугами',
        SSO_CHANGE_CONTACT: 'Изменение контактных данных',
        SSO_REQ_PIN_PUK: 'Запрос PIN/PUK',
        CLAIMS: 'Статус рассмотрения обращения',
        DETAIL: 'Заказ детализации',
        SSO_PSW_CHANGE: 'Изменение пароля',
        CHANGE_PERMISSION: 'Предоставление прав к управлению номером',
        CHANGE_CTN_STATUS: 'Блокировка или разблокировка номера',
        ACCRUE_TRAFFIC: 'Оповещение о начислении бесплатного интернет-пакета «Интернет навсегда»',
        CHANGE_SIM: 'Замена SIM-карты',
        SERVICES: 'Управление услугами',
        SSO_CHANGE_CHANNEL: 'Изменение адреса для уведомлений',
        PRICE_PLAN_CHANGE: 'Смена тарифа',
        SSO_LINK_REQUEST: 'Получение запросов от других абонентов на управление моими услугами',
      },
      confirmed: 'Подтверждено',
      notConfirmed: 'Подтвердить',
      confirmation: 'Введите код подтверждения, который мы отправили Вам на {{VALUE}}',
      tryAgain: 'Отправить код еще раз',
      emptyCodeError: 'Введите код подтверждения',
      wrongCodeError: 'Неправильный код',
      saveActionsError: 'Не удалось изменить события уведомлений, попробуйте еще раз.',
      periodicRequestTitle: 'Ежемесячная отправка детализации',
      periodicRequestIsIdle: 'Прошел год с момента активации ежемесячной отправки детализации. Для продления подписки, пожалуйста, включите ее повторно',
      periodicRequestEnd: 'Подписка действует до {{DATE}}, после чего её продление необходимо подтвердить',
      periodicRequestNumbers: 'Присылать отчёты для номеров:',
      periodicRequestSingleNumber: 'Присылать отчёты для номера:',
      periodicRequestDay: 'Отчётный период:',
      periodicRequestStartInput: 'С {{INPUT}}-го числа каждого месяца',
      periodicRequestInterval: 'Детализация будет приходить в течение недели с {{START}} по {{END}} число каждого месяца',
      periodicRequestFormat: 'В формате:',
      periodicRequestEmail: 'По почте: {{EMAIL}}',
      periodicRequestNoEmail: 'Не указан адрес электронной почты, ',
      periodicRequestSetEmail: 'указать',
      periodicRequestRenewSubscription: 'Продлить подписку',
      periodicRequestCancelSubscription: 'Отменить подписку',
    },
    passwordAndAccess: {
      name: 'Пароль и доступ',
      login: 'Логин',
      passwordSettingsTitle: 'Настройка пароля и доступа',
      passwordRecoveryTitle: 'Восстановление пароля',
      mobileAccessTitle: 'Доступ в кабинет через мобильный интернет',
      internetAccesssTitle: 'Доступ к домашнему интернету',
      mobileAccessDescription: 'При входе в «Мой билайн» с мобильного устройства вы можете получить полный или частичный доступ к личному кабинету без ввода логина и пароля',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      newLogin: 'Новый логин',
      example: 'Например',
      loginHint: 'Логин должен быть от 5 до 20 символов, латинские буквы и/или цифры, нижний регистр, первый̆ символ всегда буква',
      changePassword: 'Изменить пароль',
      enterPassword: 'Введите пароль',
      changeLogin: 'Изменить логин',
      emptyPasswordError: 'Введите текущий пароль',
      restrictedSymbolsError: 'Только латинские буквы и цифры',
      tooShortPasswordError: 'Слишком короткий пароль',
      wrongCurrentPasswordError: 'Текущий пароль указан неверно. Изменения не сохранены',
      canChangeLoginOnlyOnceAttention: 'Изменить логин можно только один раз. Логин будет использоваться для входа в систему вместо номера договора',
      loginAlreadyExistsError: 'Такой логин уже занят. Пожалуйста, выберите другой',
      changeInternetLoginSuccessPart1: '{{NEW_LOGIN}} успешно установлен в качестве Вашего логина. Для доступа к сети Интернет Вы можете продолжить использование в качестве логина {{OLD_LOGIN}} или ',
      changeInternetLoginSuccessPart2: 'перенастроить',
      changeInternetLoginSuccessPart3: ' соединение с новым логином.',
      passwordIsChanged: 'Новый пароль успешно сохранен',
      reliability: {
        short: 'Слишком короткий',
        bad: 'Ненадежный',
        good: 'Надежный',
      },
      acceptOffer: 'Я прочел и согласен с ',
      xbrOfferConditions: 'условиями доступа в кабинет через мобильный интернет',
      firstLoginAgreement: 'При первом входе вы согласились с ',
      mainOfferConditions: 'условиями использования системы самообслуживания',
      freeAccess: 'Полноценный',
      freeAccessDescription: 'Можно управлять услугами и смотреть историю операций',
      restrictedAccess: 'Ограниченный',
      restrictedAccessDescription: 'Можно посмотреть подключенные услуги и пополнить баланс, управлять услугами в ограниченном режиме нельзя',
      fullAccessTitle: 'Для полного доступа нужно будет ввести',
      password: 'пароль',
      captcha: 'код с картинки',
    },
    numberManagement: {
      name: 'Управление номерами',
      acceptRequest: 'Принять запрос',
      allow: 'Разрешить',
      decline: 'отклонить',
      cancelRequest: 'Отменить запрос',
      dataIsChanged: 'Данные успешно изменены',
      accessIsCanceled: 'Доступ к управлению аккаунтом {{LOGIN}} отменен',
      masterAccessIsCanceled: 'Доступ абонента {{LOGIN}} к вашему личному кабинету отменен',
      cancelChanges: 'Закрыть без изменений',
      unlinkMasterAccountButtonText: 'Да, запретить управление',
      unlinkChildAccountButtonText: 'Да, отказаться от управления',
      editPopup: {
        nicknameLabel: 'Краткое описание номера в списке подключённых номеров',
        contractNicknameLabel: 'Краткое описание',
        limitLabel: 'Установить порог расходов на номере',
        rubles: '₽',
        notificationCtnLabel: 'Номер для уведомлений о превышении порога',
        invoiceAddressLabel: 'Адрес доставки счетов',
        invoiceEmailLabel: 'Доставлять счета на эл. почту',
        invalidEmail: 'Введите корректный e-mail',
        invalidNotificationCtn: 'Введите корректный номер телефона',
      },
      phoneNumberConfig: {
        yourLogin: 'Ваш логин',
        nickNameLabel: 'Как Вы хотите видеть подпись к Вашему номеру в списке номеров',
        ssoLoginDefault: 'Показывать номер первым при входе в личный кабинет',
        pin: 'PIN',
        puk: 'PUK',
        codes: 'коды',
        your: 'Ваши',
        accessCodes: 'коды доступа к SIM-карте',
        notAvailable: 'Сервис временно недоступен.',
        tryLater: 'Повторите позже.',
        hint: 'При заключении договора вам были выданы следующие коды доступа к SIM-карте:',
        howToUse: 'Как пользоваться',
      },
      masterAccounts: {
        title: 'Эти абоненты могут управлять Вашим профилем',
        prohibitPhoneNumber: 'Запретить доступ к моему профилю',
        prohibitMasterAccounts: 'Запретить другим абонентам управлять моим номером',
        sendInvitation: 'Отправить приглашение',
        outgoingLinkageRequestHint: 'Приглашение отправлено, но еще не принято. Попросите этого абонента войти в свой личный кабинет и принять Ваше приглашение.',
        incomingLinkageRequestHint: 'Этот абонент просит разрешить доступ к управлению Вашими услугами, тарифами и контролировать ваши расходы. В любой момент Вы можете запретить доступ к своему кабинету.',
        emptyMessage: 'Нет абонентов, управляющих Вашим аккаунтом',
      },
      associatedAccounts: {
        title: 'Привязанные номера',
        info: 'Вы можете управлять этими номерами как своими',
        unlink: 'Отвязать',
        addPhoneNumber: 'Добавить номер',
        outgoingLinkageRequestHint: 'Запрос отправлен, но еще не принят. Попросите этого абонента зайти в свой личный кабинет и принять Ваш запрос.',
        incomingLinkageRequestHint: 'Этот абонент предлагает Вам управлять его услугами, тарифами и контролировать его расходы.',
        contractTitle: 'Договор мобильной связи № {{BAN}}',
        groupTitle: 'Группа счетов {{BEN}}',
        prepaid: 'Предоплатный',
        postpaid: 'Постоплатный',
        emptyMessage: 'Нет подключённых номеров',
      },
      associatingAccount: {
        title: 'Добавление номера',
        passwordIsAvailable: 'Я знаю пароль от личного кабинета добавляемого номера или договора',
        userLoginLabel: 'Введите логин кабинета для добавления',
        userPasswordLabel: 'Введите пароль от добавляемого кабинета',
        loginHint: 'Номер телефона в формате 9037125674 (без +7, пробелов и скобок), или номер лицевого счёта Домашнего билайн в формате 08ХХХХХХХХ, или логин из букв и цифр',
        linkingSuccess: 'Абонент успешно привязан к вашему кабинету',
        linkingAccountSuccess: 'Абонент {{LOGIN}} успешно привязан к вашему кабинету',
        unlinkConfirmationMessage: 'Вы уверены, что хотите отказаться от управления аккаунтом {{LOGIN}}?',
        unlinkConfirmationDescription: 'После отказа от аккаунта, он не будет присутствовать в списке доступных для управления. Подключенные на этом аккаунте услуги останутся без изменения.',
        unlinkMasterConfirmationMessage: 'Вы уверены, что хотите отменить доступ к управлению аккаунтом {{LOGIN}}?',
        unlinkMasterConfirmationDescription: 'После отмены доступа аккаунту будет недоступно управление вашим личным кабинетом',
        linkRequestIsSentTitle: 'Запрос отправлен',
        linkRequestIsSent: 'Запрос отправлен, но еще не принят. Попросите абонента {{LOGIN}} войти в свой личный кабинет и принять ваш запрос.',
        accountLinkIsCanceling: 'Запрос отменяется',
        acceptOffer: 'Нажимая на кнопку «Добавить», я соглашаюсь с',
        offerConditions: 'условиями предоставления услуги',
        errorMessages: {
          LINKABLE_ACCOUNT_NOT_FOUND: 'Абонент не существует',
          LINKABLE_ACCOUNT_IS_BLOCKED: 'Этот аккаунт заблокирован',
          ALREADY_LINKED: 'Вы уже можете управлять услугами этого пользователя',
          LINKAGE_REQUEST_ALREADY_EXISTS: 'Вы уже отправляли запрос на управление услугами этого пользователя',
          BASE_ACCOUNT_LINKAGE_NOT_ENABLED: 'Невозможно привязать самого себя',
          LINKAGE_FORBIDDEN: 'Привязываемый аккаунт запретил привязки',
          INVALID_LINKABLE_ACCOUNT_HIERARCHY: 'Привязываемый аккаунт имеет недопустимую иерархию',
          WRONG_LINKABLE_ACCOUNT_PASSWORD: 'Вы ввели неправильный пароль',
          INVITE_REQUEST_ALREADY_EXISTS: 'Вы уже отправляли приглашение на управление услугами этому пользователю',
          ALREADY_INVITED: 'Привязываемый аккаунт уже управляет Вашими услугами',
          AMBIGUOUS_USER_TYPE: 'Такой логин существует и для домашнего и для мобильного аккаунта. Какой аккаунт нужен вам?',
        },
        userTypes: {
          Mobile: 'Мобильный',
          Fttb: 'Домашний',
        },
      },
    },
    passportUpload: {
      name: 'Обновление персональных данных',
      title: 'Договор об оказании услуг связи',
      warning: 'Уважаемый абонент, в соответствии с требованиями законодательства мы обязаны попросить вас об уточнении сведений, указанных в абонентском договоре.',
      headingRequiredActionConfirm: 'Как предоставить необходимые сведения',
      headingRequiredActionNone: 'С вашими персональными данными по договору все в порядке. Но если ваши данные поменялись, здесь вы можете сообщить нам об этом. Выберите способ',
      tooLargeError: 'Файл слишком большой. Попробуйте загрузить другой файл',
      postError: 'Не удалось загрузить файлы. Попробуйте еще раз',
      postSuccess: 'Файл успешно отправлен!',
      postDelay: 'Ваше обращение будет рассмотрено за 5 рабочих дней. Решение по нему мы отправим вам в SMS.',
      headingFirstCase: 'Загрузить фото документа',
      headingSecondCase: 'Госуслуги',
      headingThirdCase: 'В офисе',
      descriptionFirstCase: 'Загрузите сфотографированные или отсканированные изображения вашего паспорта. Подойдут форматы PDF, JPG, JPEG, PNG, GIF, TIFF размером до 10 МБ.',
      descriptionSecondCase: 'Обновите ваши данные из вашего аккаунта Госуслуги.',
      descriptionThirdCase: 'Зайдите в <a href="/customers/beeline-map/">ближайший</a> офис продаж билайн. Наш сотрудник поможет вам в регистрации договора на обслуживание.',
      unsupportedBrowser: 'Браузер Internet Explorer не поддерживается. Установите одну из современных альтернатив: Google Chrome, Mozilla Firefox, Яндекс.Браузер, Opera.',
      passport: {
        title: 'Файл 1: разворот с ФИО и данными паспорта',
      },
      registration: {
        title: 'Файл 2: разворот с адресом регистрации',
        text: 'Если записей несколько, сфотографируйте так, чтобы была видна последняя регистрация.',
      },
      earlyPassports: {
        title: 'Файл 3: разворот со сведениями о ранее выданных паспортах (только для граждан РФ)',
        text: 'Если записей несколько, сфотографируйте так, чтобы была видна последняя запись.',
      },
      uploadFile: 'Загрузить',
      uploadButton: 'Отправить сведения',
      needMorePhoto: 'Добавьте недостающие изображения',
      buttonFirstCaseInitial: 'Загрузить файл...',
      buttonFirstCaseOther: 'Загрузить другой файл...',
      buttonFirstCaseSend: 'Отправить',
      buttonSecondCaseUpdate: 'Обновить',
      buttonSecondCaseTryAgain: 'Попробовать еще раз',
      agreement: '*информация об успешном подтверждении персональных данных будет отправлена в SMS',
      tip: 'Нажимая «Отправить сведения», вы соглашаетесь на обработку персональных данных, которые передаёте.',
    },
  },
  messages: {
    title: {
      month: 'Уведомления за месяц',
      year: 'Уведомления за год',
    },
    table: {
      header: {
        content: 'Содержание',
        status: 'Статус',
        date: 'Дата',
      },
    },
    loadMore: 'Загрузить уведомления за год',
    attachmentTitle: '{{TITLE}} с {{FROM}} по {{TO}}',
    download: 'Скачать',
    remove: 'Удалить отмеченные',
    supportAnswer: 'Ответ службы поддержки',
    emptyMessage: {
      month: 'Нет уведомлений за последний месяц',
      year: 'Нет уведомлений за последний год',
    },
    isNotAllMessagesError: 'Не удалось загрузить часть сообщений',
    tryAgain: 'попробуйте ещё раз',
  },
  tv: {
    tv: {
      blockTitle: 'Телевидение',
      connect: 'Подключить ТВ',
      connectInfo: 'От {{PRICE}} ₽ за {{COUNT}}',
    },
    packages: {
      blockTitle: 'Пакеты каналов',
    },
    subscriptions: {
      blockTitle: 'Подписки',
    },
    services: {
      blockTitle: 'Дополнительные услуги',
    },
    devices: {
      blockTitle: 'Устройства {{COUNT}}',
      mac: 'MAC-адрес: {{MAC}}',
      serial: 'Серийный номер: {{SERIAL}}',
      guid: 'GUID: {{GUID}}',
    },
    messages: {
      servicesDisconnect: 'Запрос №{{ID}} на отключение успешно отправлен, подробности в разделе',
      connectionDate: 'Услуга ожидает подключения {{DATE}} в {{TIME}}, запрос №{{REQUEST_ID}}',
      disconnectionDate: 'Услуга ожидает отключения {{DATE}} в {{TIME}}, запрос №{{REQUEST_ID}}',
      nextService: '{{DATE}} в {{TIME}} будет произведена смена на услугу {{NEXT_SERVICE}}, запрос №{{REQUEST_ID}}',
      nextServiceNoDate: 'Мы еще обновляем состав Вашего тарифа. За статусом следите в разделе Сообщения',
      futureRequest: 'Запрос №{{ID}} успешно отправлен',
    },
  },
  internet: {
    internet: {
      blockTitle: 'Домашний интернет',
      unavailableForYourRegionText: 'Услуга не предоставляется в вашем тарифе',
    },
    devices: {
      blockTitle: 'Устройства',
      serial: 'Серийный номер: {{SERIAL}}',
    },
    services: {
      blockTitle: 'Дополнительные услуги',
    },
    antivirus: {
      key: 'Ключ активации: {{KEY}}',
      login: 'Логин: {{LOGIN}}',
      password: 'Пароль: {{PASSWORD}}',
      installUrl: 'Программа установки',
      manualUrl: 'Инструкция по установке',
    },
    agreementRenewal: {
      message: 'Вы оформили заявку на переоформление договора {{NUMBER}} Домашнего интернета и Домашнего телевидения на нового владельца: {{NAME}}. В случае подтверждения согласия, все обязательства по данному договору, включая выплаты за купленное/арендованное оборудование, переходят к новому владельцу после его визита в {{OFFICES}} и подтверждения переоформления.',
      agreement: 'Я даю своё {{AGREEMENT}} на переоформление договора {{NUMBER}}',
      support: 'Если Вы не заказывали переоформление договора, свяжитесь, пожалуйста, с нами по номеру 8 800 700-8000 (звонок бесплатный)',
      successConfirm: 'Переоформление договора на {{NAME}} подтверждено',
      successRefuse: 'Переоформление договора на {{NAME}} отклонено',
    },
    address: {
      blockTitle: 'Адрес подключения',
      changeAdress: 'Изменить адрес',
    },
    newAddress: {
      messageLite: 'Уважаемый абонент!\nВы заказали услугу «Переезд» на адрес: {{ADDRESS}}\n\nУслуга «Переезд» позволяет изменить адрес подключения без изменения условий договора. Ваш баланс, тарифный план, подключенные услуги и сервисы не изменятся.\n\nПроверьте, пожалуйста, доступность наших услуг по вашему новому адресу проживания и подтвердите факт переезда.',
      messageHardToday: 'Уважаемый абонент, Вы оформили заявку на услугу «Переезд»\n\nСегодня ({{DATE}}) к Вам приедет технический специалист для подключения ваших услуг Домашнего Интернета и/или ТВ по новому адресу проживания: {{ADDRESS}}\n\nЕсли работы по подключению Вас к сети по новому адресу выполнены, введите код подтверждения переезда (код подтверждения находится у технического специалиста)',
      messageHardTomorrow: 'Уважаемый абонент, Вы оформили заявку на услугу «Переезд»\n\n{{DATE}} к Вам приедет технический специалист для подключения ваших услуг Домашнего Интернета и/или ТВ по новому адресу проживания: {{ADDRESS}}\n\nВаш баланс, тарифный план, подключенные услуги и сервисы не изменятся',
      agreement: 'Я согласен на перенос договора на мой новый адрес',
      support: 'Если вы не заказывали услугу «Переезд» или вам не удалось настроить соединение, пожалуйста, свяжитесь с нами по номеру 8 800 700-8000 (звонок бесплатный)',
      success: 'Поздравляем с новосельем, ваш билайн',
    },
    newAddressForm: {
      title: 'Услуга «Переезд»',
      description: 'Теперь при переезде в новую квартиру Домашний интернет и Домашнее цифровое телевидение «билайн» можно взять «с собой». Сохраняйте номер договора, логин (CTN), пароль, тарифный план, баланс лицевого счета, оборудование и все подключенные услуги. Услуга предоставляется бесплатно.',
      formTitle: 'Новый адрес',
    },
    messages: {
      servicesDisconnect: 'Запрос №{{ID}} на отключение успешно отправлен, подробности в разделе',
      connectionDate: 'Услуга ожидает подключения {{DATE}} в {{TIME}}, запрос №{{REQUEST_ID}}',
      disconnectionDate: 'Услуга ожидает отключения {{DATE}} в {{TIME}}, запрос №{{REQUEST_ID}}',
      socialInternetDisconnectionDate: 'Услуга ожидает отключения {{DATE}} в {{TIME}}',
      nextService: '{{DATE}} в {{TIME}} будет произведена смена на услугу {{NEXT_SERVICE}}, запрос №{{REQUEST_ID}}',
      nextServiceNoDate: 'Будет произведена смена на услугу {{NEXT_SERVICE}}, запрос №{{REQUEST_ID}}',
      successRequest: 'Запрос №{{ID}} успешно отправлен',
    },
    speedUp: {
      heading: 'Услуга «Выбор скорости»',
      description: 'Без проблем позволит максимально увеличить скорость вашего тарифного плана в любое время без смены текущего тарифного плана',
      baseSpeed: 'Базовая скорость по тарифу {{SPEED}} Мбит/с',
      newSpeedLabel: 'Входящая скорость, которую вы хотите получить',
      rateLabel: 'Абонентская плата',
      connectPrice: 'Стоимость подключения услуги: {{PRICE}}',
      connectionByRequest: 'Подключение данного значения скорости осуществляется только при наличии технической возможности. При нажатии на кнопку «Проверить техническую возможность» заявка на проверку будет создана автоматически. Наши сотрудники свяжутся с вами для уточнения деталей подключения.',
      checkConnection: 'Проверить техническую возможность',
      selectNewSpeed: 'Выберите новую скорость',
      totalPrice: 'Размер абонентской платы составит: {{PRICE}} ₽ в месяц',
    },
    routerBuyRequest: {
      message: 'Вы заказали роутер {{MODEL}}. Стомость покупки {{PRICE}} ₽',
      discount: 'Скидка составила {{SUM}} ₽',
      buy: 'Перейти к оплате',
    },
    multiconvergence: {
      mobileRegion: 'Мобильная связь: {{MOBILEREGION}}',
      internetRegion: 'Домашний интернет: {{INTERNETREGION}}',
    },
  },
  insurance: {
    blockTitle: 'Страхование',
    insuranceSum: 'Страховая выплата до {{SUM}} ₽',
    policyLink: 'Скачать страховой полис №{{NUMBER}}',
    currentPeriodPaid: 'Страховка активна до {{DATE}}',
    onlyFuturePeriodPaid: 'Страховка начнет действовать с {{DATE}}',
    noLastPayedPeriod: 'Страховка не оплачена',
    helpMessage: 'Есть вопросы? Звоните по бесплатному номеру 8\u00a0800\u00a0700\u20118000',
    noServiceMessage: 'Страхование квартиры ещё не подключено',
    noServiceInfo: 'Страхование имущества, отделки в вашей квартире и гражданской ответственности',
    periods: {
      link: 'Периоды действия страховки',
      dates: 'Период',
      status: 'Статус',
    },
    disabledService: 'Услуга страхования квартиры отключена, поэтому автоматическое продление на следующий период не произойдёт',
    disableDialog: 'Отключение услуги',
    disableDialogAttention: 'После отключения услуги страховка будет действовать до конца оплаченного периода',
    disableSuccess: 'Запрос №{{ID}} на отключение услуги успешно отправлен',
  },
  ipoe: {
    isAvailable: 'Теперь не нужно каждый раз подключать интернет заново.\nС технологией IPoE достаточно сделать это один раз.',
    moreAbout: 'Узнать о технологии',
    connect: 'Подключить IPoE',
    isConnected: 'Уже перешли на IPoE?',
    updateStatus: 'Обновить статус подключения',
    updateError: 'При выполнении запроса произошла ошибка.\nПовторите запрос поздее или обратитесь в Центр поддержки клиентов по номеру 8\u00a0800\u00a0700\u20118000',
    isActive: 'Подключение по IPoE активно',
    disconnect: 'Прервать соединение',
    disconnectConfirmation: 'Вы действительно хотите прервать соединение по IPoE?\nПри следующей попытке перейти на сайт в интернете мы спросим у вас логин и пароль.',
    isDisconnected: 'Разрыв соединения произойдёт в течение 15 минут.\nЧтобы изменения вступили в силу, необходимо обновить страницу',
    notBeelineNetwork: 'Вход в интернет по IPoE доступен только с компьютера, подключеннного к сети билайн',
    password: {
      captive: 'Пароль для доступа к сети интернет изменен. Необходимо авторизоваться на Captive Portal с новым паролем.',
      autoupdate: 'Пароль для доступа к сети интернет автоматически изменен на роутере. Дополнительных настроек устройства не требуется.',
      needUpdate: 'Пароль для доступа к сети интернет изменен. Теперь для входа в интернет используйте Ваш новый пароль. Если Вы используете Wi-Fi роутер, то не забудьте установить в его настройках Ваш новый пароль.',
    },
  },
  family: {
    title: 'Семья в билайне',
    sdbDescriptionText: 'Можно делиться гигабайтами.',
    sebDescriptionText: 'Можно делиться гигабайтами, минутами, SMS.',
    sebAndSdbSocketsText: 'Подключённые номера платят только за услуги в роуминге и платные подписки',
    noLimitSetText: 'Лимит не установлен',
    familyInvitationSent: 'Приглашение в семью отправлено',
    numberIsConnectedText: 'Номер подключён',
    cancelInviteBtnText: 'Отменить приглашение',
    serviceTermsNumberLabel: 'Номера',
    serviceTermsCostLabel: 'Стоимость',
    serviceSocketsLabel: 'Пакеты',
    disconnectBtnText: 'Отключиться от семьи',
    frequentTitle: 'Частые вопросы',
    ctnSetupTexts: {
      cancelButtonText: 'Отключить услугу',
      ctnSettingsTitle: 'Настройки абонента',
      ctnLimitsText: 'Лимиты основного пакета',
      shareAllText: 'Делиться всем',
      tariffDetailsText: 'Подробнее о тарификации при лимитах',
      removeBtnText: 'Удалить номер из семьи',
      saveBtnText: 'Сохранить новые лимиты',
      showAllTariffsBtnText: 'Смотреть тарифы',
    },
    errorPage: {
      title: 'Что-то пошло не так',
      description: 'Страница не отвечает на запрос. Попробуйте ещё раз',
      buttonText: 'Обновить страницу',
    },
    setFamilyChildLimitsStatus: 'Значение больше, чем ваш остаток по пакету. Оно применится после обновления пакета',
  },
};
